import type { ContentCompetency } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (
  contentCompetency?: ContentCompetency,
  categoryName?: string,
  nuggetCount?: number,
  toolCount?: number,
  playlistCount?: number,
) => {
  useRegisterAgentContext(
    contentCompetency
      ? {
          kind: 'entity',
          description: 'The competency the user is viewing',
          data: {
            ...contentCompetency,
            categoryName,
            nuggetCount,
            toolCount,
            playlistCount,
          },
        }
      : null,
  );
};
